import script from "./news.vue?vue&type=script&setup=true&lang=js"
export * from "./news.vue?vue&type=script&setup=true&lang=js"

import "./news.css?vue&type=style&index=0&id=536b5fc4&scoped=true&lang=css"
import "./news.vue?vue&type=style&index=1&id=536b5fc4&lang=css"

import exportComponent from "D:\\work\\gw-sh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536b5fc4"]])

export default __exports__